import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { App } from "@/App";
import { queryClient } from "@/lib/queryClient";
import { initObservability } from "@/lib/observability";
import "@/index.css";

void initObservability();

const root = document.getElementById("root");
if (!root) throw new Error("Element #root introuvable dans index.html");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
